module.exports = __webpack_public_path__ + "img/threesides-online.d30c5ec.svg";